import { css, styled } from 'styled-components';
import { Sizes } from 'styles/constants';

import { Colors } from 'styles/enums';
import { mediaQueries } from 'styles/helpers';

export const TabsSectionWrapper = styled.div`
  max-width: ${Sizes.maxWidth}px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  row-gap: 3.75rem;
  ${mediaQueries(
    'md',
    css`
      row-gap: 1.5rem;
      width: 100%;
    `
  )}
  ${mediaQueries(
    'lg',
    css`
      row-gap: 1.5rem;
      width: 100%;
    `
  )}
`;

export const TabSectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 160px;
`;

const getBorder = ($selected: boolean) => {
  return css`
    ${mediaQueries(
      'md',
      css`
        border-bottom: ${$selected ? '3px solid' : '1px solid'};
        border-color: ${$selected ? Colors.Yellow.base100 : Colors.UI.base070};
      `
    )}
    ${mediaQueries(
      'lg',
      css`
        border-bottom: ${$selected ? '3px solid' : '1px solid'};
        border-color: ${$selected ? Colors.Yellow.base100 : Colors.UI.base070};
      `
    )}
  `;
};

export const TabSectionHeaderItem = styled.button<{ $selected: boolean }>`
  display: none;

  ${mediaQueries(
    'lg',
    css`
      width: 100%;
      display: flex;
      justify-content: center;
      border: none;
      background: inherit;
      cursor: pointer;
    `
  )}

  ${mediaQueries(
    'md',
    css`
      width: 100%;
      display: flex;
      justify-content: center;
      border: none;
      background: inherit;
      cursor: pointer;
    `
  )}

  ${({ $selected }) => getBorder($selected)}
`;

const getDisplay = ($selected: boolean) => {
  return css`
    ${mediaQueries(
      'md',
      css`
        display: ${$selected ? 'flex' : 'none'};
      `
    )}
    ${mediaQueries(
      'lg',
      css`
        display: ${$selected ? 'flex' : 'none'};
      `
    )}
  `;
};

export const TabSectionWrapper = styled.div<{ $selected: boolean }>`
  display: flex;

  ${({ $selected }) => getDisplay($selected)}
`;
